export var Spinner = {
    defaultProps: {
        color: 'primary.600',
    },
};
